import React, { useEffect } from "react";
import "./stylee.scss";
import { FaUserAlt, FaLock, FaGoogle, FaHome } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { useState, useContext } from "react";
import { processLogin, processLoginGG } from "services/user/userService";
import { OAuthConfig } from "Configurations/configGG";
import { PacmanLoader } from "react-spinners";
import { BiSolidErrorCircle } from "react-icons/bi";
import { checkTokenExpiration } from "services/tokenService";
// import { FaLock } from "react-icons/fa";
import { HiOutlineLockClosed } from "react-icons/hi";

const LoginForm = () => {
  const [isLoading, setIsLoading] = useState(false);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [userInfors, setUserInfors] = useState([]);
  const navigate = useNavigate();

  const handleGoogleLogin = () => {
    const callbackUrl = OAuthConfig.redirectUri;
    const authUrl = OAuthConfig.authUri;
    const googleClientId = OAuthConfig.clientId;

    const targetUrl = `${authUrl}?redirect_uri=${encodeURIComponent(
      callbackUrl
    )}&response_type=code&client_id=${googleClientId}&scope=openid%20email%20profile`;

    console.log(targetUrl);

    window.location.href = targetUrl;
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); //
    try {
      setIsLoading(true);
      const response = await processLogin(email, password);
      if (response.status === 200) {
        const token = response.data.data.token;
        const name = response.data.data.fullName;
        const role = response.data.data.role;
        const expirationTime = Date.now() + 3600 * 1000;

        localStorage.setItem("name", name);
        localStorage.setItem("token", token);
        localStorage.setItem("role", role);
        localStorage.setItem(
          "itemQuantityInCart",
          response.data.data.itemQuantityInCart
        );
        localStorage.setItem("expirationTime", expirationTime);
        checkTokenExpiration(navigate);

        if (role === "user") {
          navigate("/");
        } 
        else if (role === "superadmin" || role === "admin") navigate("/admin");
      }
      // else if (response.status === 401){
      //   setError("Fail to login: Incorrect email or password.");
      // }
    } catch (err) {
      if (err?.response?.data?.message === "User not found!") {
        setError("Không tìm thấy tài khoản!");
      } else if (err?.response?.data?.message === "Log in failed!") {
        setError("Mật khẩu không chính xác!");
      } else if (err?.response?.data?.message === "Unactivated account!") {
        setError("Bạn chưa xác minh tài khoản!");
      } else if (err?.response?.data?.message === "Permission denied!") {
        setError("Tài khoản của bạn đã bị khóa!");
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="helo">
      <div className="login-form">
        <form onSubmit={handleSubmit}>
          <h1>Đăng nhập</h1>

          <div className="input-box">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <FaUserAlt className="icon" />
          </div>

          <div className="input-box">
            <input
              type="password"
              placeholder="Mật khẩu"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <FaLock className="icon" />
          </div>

          {error && (
            <div className="error-message">
              <span className="error-icon">
                <BiSolidErrorCircle />
              </span>{" "}
              {/* Dấu "x" */}
              <span>{error}</span>
            </div>
          )}

          <button className="login" type="submit" data-testid="login-submit">
            Đăng nhập
          </button>

          <button className="google-login" onClick={handleGoogleLogin}>
            <FaGoogle className="icon" /> Đăng nhập với Google
          </button>
          <div className="register-link">
            <p>
              Bạn chưa có tài khoản? <Link to="/register">Đăng kí</Link>
            </p>
          </div>
          <div className="remember-forgot">
            <Link to="/forgot-password">
              <HiOutlineLockClosed className="icon-lock" /> Quên mật khẩu
            </Link>
          </div>

          <div className="homepage">
            <Link to="/">
              <FaHome />
            </Link>
          </div>
        </form>
      </div>
      {isLoading && (
        <div className="modal">
          <div className="overlay_loading">
            <div className="modal-content_loading">
              <div className="d-flex">
                <PacmanLoader color="#5e2e86" />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LoginForm;
